export const version = '2.12.0';
//# sourceMappingURL=version.js.map